import { z } from 'zod'
import { ParkingCard } from '~/shared/api'
import { OptionEnum } from '~/shared/config/constants'
import { ParkingCardVehicleTypeEnum } from '~/shared/config/enums'

export const formSchema = ParkingCard.schema.pick({
  series: true,
  number: true,
  paidAmount: true,
  paymentDate: true,
  expirationDate: true,
  vehicleType: true,
})

type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = Omit<TypeFormSchema, 'vehicleType'> & {
  vehicleType:
    | ParkingCardVehicleTypeEnum
    | OptionEnum<ParkingCardVehicleTypeEnum>
}
